import { TabContentParameters } from "./TabContentParameters";

export class LeitorContentParameters {
  tabContentParameters: TabContentParameters;

  constructor() {
    this.tabContentParameters = new TabContentParameters();
  }
}
